import React from 'react';
import PropTypes from 'prop-types';
import ActivePokemon from '../ActivePokemon';
import BenchSlot from '../Bench/BenchSlot';
import Deck from '../Deck';
import DiscardPile from '../DiscardPile';
import PrizeSlot from '../Prizes/PrizeSlot';
import Anchor from '../Motion/Anchor';
import OpponentHand from './OpponentHand';
import { anchors } from '../Motion/anchorNames';
import { BENCH_POSITIONS, PRIZE_POSITIONS } from './layout';
import { Active, BenchRow, Front, Piles, PrizeGrid, Side, Table, TableDivider, TableHandEdge } from './styled';

/** One player's side: prizes, active Pokémon and piles in front, the bench behind. */
const TableSide = ({ userId, opponent }) => (
  <Side $opponent={opponent}>
    {/* The opponent's draws and prizes go past their side, toward them (column-reverse puts this on top). */}
    {opponent && <Anchor name={anchors.hand(userId)}><TableHandEdge><OpponentHand userId={userId} /></TableHandEdge></Anchor>}
    <Front>
      <PrizeGrid aria-label="Prizes">
        {PRIZE_POSITIONS.map(position => (
          <Anchor key={position} name={anchors.prize(userId, position)}><PrizeSlot userId={userId} position={position} /></Anchor>
        ))}
      </PrizeGrid>
      <Active><Anchor name={anchors.active(userId)}><ActivePokemon userId={userId} /></Anchor></Active>
      <Piles>
        <Anchor name={anchors.deck(userId)}><Deck userId={userId} /></Anchor>
        <Anchor name={anchors.discard(userId)}><DiscardPile userId={userId} /></Anchor>
      </Piles>
    </Front>
    <BenchRow aria-label="Bench">
      {BENCH_POSITIONS.map(position => (
        <Anchor key={position} name={anchors.bench(userId, position)}><BenchSlot userId={userId} position={position} /></Anchor>
      ))}
    </BenchRow>
  </Side>
);

TableSide.propTypes = {
  userId: PropTypes.number.isRequired,
  opponent: PropTypes.bool,
};

/** The game laid out for a phone screen: bigger cards, every card upright. */
const TableBoard = ({ playerId, opponentId }) => (
  <Table>
    <TableSide userId={opponentId} opponent />
    <TableDivider />
    <TableSide userId={playerId} />
  </Table>
);

TableBoard.propTypes = {
  playerId: PropTypes.number.isRequired,
  opponentId: PropTypes.number.isRequired,
};

export default TableBoard;
